import React from 'react';
import PropTypes from 'prop-types';
import { TickList } from 'web-ui-components/lib/typography/lists';
import { StandardBody, SubBody } from 'web-ui-components/lib/typography/body';
import { StandaloneCheckbox } from 'web-ui-components/lib/data/capture';

function LetsChatDecisionModal(props) {
  return (
    <div>
      <br />
      <StandardBody>
        <p>
          <strong>{props.content.youCanSendMessage}</strong>
        </p>
      </StandardBody>
      <SubBody>
        <p>{props.content.manyCustomersAreUsingMsg}</p>
        <p>{props.content.withLetsChatMsg}</p>
        <TickList
          items={[
            <SubBody>
              <p>{props.content.withLetsChatDescList.getInTouchMsg}</p>
            </SubBody>,
            <SubBody>
              <p>{props.content.withLetsChatDescList.getAnInstantReplyMsg}</p>
            </SubBody>,
            <SubBody>
              <p>{props.content.withLetsChatDescList.manageYourAccountMsg}</p>
            </SubBody>,
          ]}
        />
        <p>{props.content.easyToUseMsg}</p>
      </SubBody>
      <br />
      <div className="button-group">
        <button
          className="c-btn c-modal__button c-btn--secondary"
          onClick={props.continueWithSecureMessaging}
          style={{ 'margin-right': '10px' }}
        >
          {props.content.continueToSecMsgBtnTxt}
        </button>
        <button
          className="c-btn c-modal__button c-btn--default"
          onClick={props.handleLetsChat}
        >
          {props.content.letsChatBtnTxt}
        </button>
      </div>
      <br />
      <StandaloneCheckbox
        isChecked={props.dontShowAgain}
        labelText={props.content.dontShowAgainMsg}
        id="dont-show-again"
        onChange={props.handleDontShowAgainOnChange}
      />
    </div>
  );
}

LetsChatDecisionModal.propTypes = {
  content: PropTypes.object,
  continueWithSecureMessaging: PropTypes.func.isRequired,
  handleLetsChat: PropTypes.func.isRequired,
  dontShowAgain: PropTypes.bool.isRequired,
  handleDontShowAgainOnChange: PropTypes.func.isRequired,
};

export { LetsChatDecisionModal };
